import React from 'react';
import partial from 'lodash/partial';
import includes from 'lodash/includes';
import {FormattedMessage} from 'react-intl';
import {Link, Redirect} from 'react-router-dom';
import {Grid, Header, Button} from 'semantic-ui-react';
import {bool, string, object, func, number, oneOf, arrayOf} from 'prop-types';
import ImageEditModalContainer from 'pages/Images/ImageEditModalContainer';
import StatusModal from 'components/common/StatusModal';
import {SitesByLanguage} from 'utils/DBUtils';
import RewardsTable from './RewardsTable';
import StoreStockModal from './StoreStockModal';
import TotalsOverview from './TotalsOverview';
import PurchaseInfoModal from './PurchaseInfoModal';
import RetailerItemModalContainer from '../RetailerItemModal/RetailerItemModalContainer';
import {TableViewModes, RetailerItemFormModes} from '../utils';

const canAddRetailerItems = mode => includes([TableViewModes.Live, TableViewModes.Planning], mode);

const RewardsTableView = props => !props.escrowExists ? <Redirect to='/rewards' /> : (
  <div className={`rewards-list ${props.tableMode.toLowerCase()}-mode`}>
    <Grid className='rewards-page-header'>
      <Grid.Row columns={props.tableMode === TableViewModes.Planning ? 3 : 2}>
        <Grid.Column>
          <Header as='h1'>
            <FormattedMessage
              id={`rewardsStore.table.mode.${props.tableMode}.header`}
              values={{
                  site: SitesByLanguage[props.lang],
                  month: props.monthName,
                  year: props.year
              }} />
          </Header>
        </Grid.Column>
        {props.tableMode === TableViewModes.Planning && (
          <Grid.Column>
            <FormattedMessage id='rewardsStore.table.mode.Planning.description' />
          </Grid.Column>
        )}
        <Grid.Column textAlign='right'>
          <Link to='/rewards'>
            <FormattedMessage id='rewardsStore.table.link.dashboard' />
          </Link>
        </Grid.Column>
      </Grid.Row>
    </Grid>
    <RewardsTable {...props} />
    {canAddRetailerItems(props.tableMode) && (
      <Button
        primary
        className='add-retailer-item-button'
        onClick={partial(props.openRetailerItemModal, RetailerItemFormModes.Create)}>
        <FormattedMessage id='rewardsStore.table.button.add' />
      </Button>
    )}
    <Button
      primary
      className='export-button'
      loading={props.exportingStoreData}
      onClick={partial(props.exportStoreData, props.lang, props.currentEscrowId)}>
      <FormattedMessage id='rewardsStore.table.button.export' />
    </Button>
    <TotalsOverview
      currency={props.currency}
      escrow={props.currentEscrow} />
    <StoreStockModal
      currency={props.currency}
      mode={props.storeStockFormMode}
      availableBudget={props.currentEscrow.available}
      reward={props.updatingStoreStockFor}
      onClose={props.closeStoreStockModal}
      onSubmit={props.submitStoreStockForm}
      isOpen={Boolean(props.updatingStoreStockFor)} />
    <RetailerItemModalContainer />
    <ImageEditModalContainer />
    <StatusModal
      isOpen={props.exportedStoreData}
      success={props.exportStoreDataSuccess}
      onClose={props.closeExportStatusModal}
      errorHeaderKey='rewardsStore.modal.export.header.error'
      errorMessageKey='rewardsStore.modal.export.message.error'
      successHeaderKey='rewardsStore.modal.export.header.success'
      successMessageKey='rewardsStore.modal.export.message.success' />
    {props.viewingPurchaseInfoFor && (
      <PurchaseInfoModal
        year={props.year}
        month={props.month}
        storeOrders={props.storeOrders}
        isOpen={props.viewingPurchaseInfo}
        getStoreOrders={props.getStoreOrders}
        onClose={props.closePurchaseInfoModal}
        resendOrderEmail={props.resendOrderEmail}
        retailerItem={props.viewingPurchaseInfoFor}
        isInFlightFor={props.resendOrderEmailSubmittedFor}
        resendWasSuccessfulFor={props.resentOrderEmailFor} />
    )}
  </div>
);

RewardsTableView.propTypes = {
  escrowExists: bool.isRequired,
  tableMode: oneOf(Object.keys(TableViewModes)).isRequired,
  lang: string.isRequired,
  currency: string.isRequired,
  monthName: string.isRequired,
  currentEscrow: object.isRequired,
  currentEscrowId: number.isRequired,
  openRetailerItemModal: func.isRequired,

  exportingStoreData: bool.isRequired,
  exportedStoreData: bool.isRequired,
  exportStoreData: func.isRequired,
  closeExportStatusModal: func.isRequired,

  storeStockFormMode: string.isRequired,
  updatingStoreStockFor: object.isRequired,

  getStoreOrders: func.isRequired,
  storeOrders: arrayOf(object).isRequired,
  viewingPurchaseInfo: bool.isRequired,
  viewingPurchaseInfoFor: object.isRequired,
  resendOrderEmail: func.isRequired,
  resendOrderEmailSubmittedFor: number.isRequired,
  resentOrderEmailFor: number.isRequired,
  closePurchaseInfoModal: func.isRequired
};

export default RewardsTableView;



// WEBPACK FOOTER //
// ./public/pages/Rewards/RewardsTable/RewardsTableView.jsx